<div class="content d-flex flex-column" [ngStyle]="{
    backgroundColor: (Merchant$ | async)?.webapp_settings
      ?.homepage_bottom_color,
  }">
  <section class="page-content d-flex align-items-center justify-content-center flex-fill">
    <div class="login-box">
      <div class="login-box-body">
        <form #LoginForm="ngForm" (ngSubmit)="attemplogin(LoginForm)" novalidate>
          <div class="d-grid mb-4">
            <!-- guest_access_allowed used to use app thrugh the guest user   -->
            @if ((Merchant$ | async)?.webapp_settings?.guest_access_allowed) {
              <button type="button" (click)="Guestlogin(true)" class="btn btn-lg" [ngStyle]="{
                                backgroundColor: (Merchant$ | async)?.webapp_settings
                                  ?.menu_color,
                                color: (Merchant$ | async)?.webapp_settings
                                  ?.menu_font_color_homepgae,
                                border:
                                  (Merchant$ | async)?.webapp_settings?.menu_border_width +
                                  'px solid ' +
                                  (Merchant$ | async)?.webapp_settings?.menu_border_color,
                              }">
                Proceed as guest
              </button>
            }
          </div>
          <div class="form-group">
            <label [ngStyle]="{
                            color: (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae,
                          }">Email address
              <i class="zmdi zmdi-help-outline" (click)="LoginInfo()"></i>
            </label>
            <input type="text" id="username" name="txtusername" ngModel required class="form-control form-control-lg"
              placeholder="Email ID" />

            @if (
            LoginForm?.controls["txtusername"]?.invalid &&
            (LoginForm?.controls["txtusername"].dirty ||
            LoginForm?.controls["txtusername"].touched)
            ) {
            <div>
                @if (LoginForm?.controls["txtusername"].errors.required) {
                <span [ngStyle]="{
                                      color: (Merchant$ | async)?.webapp_settings
                                        ?.menu_font_color_homepgae,
                                    }">
                  please fill Email address.
                </span>
                }
                </div>
            }
          </div>
          <div class="form-group">
            <label [ngStyle]="{
                            color: (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae,
                          }">Password</label>
            <input type="password" name="txtpassword" id="password" ngModel required class="form-control form-control-lg"
              placeholder="Password" />
            @if (
            LoginForm.controls["txtpassword"]?.invalid &&
            (LoginForm.controls["txtpassword"].dirty ||
            LoginForm.controls["txtpassword"].touched)
            ) {
            <div>
                @if (LoginForm.controls["txtpassword"].errors.required) {
                <span [ngStyle]="{
                                      color: (Merchant$ | async)?.webapp_settings
                                        ?.menu_font_color_homepgae,
                                    }">
                  please fill Password.
                </span>
                }
                </div>
            }
          </div>
          <div class="d-grid">
            <button type="submit" id="btnlogin" (ngSubmit)="attemplogin(LoginForm)" class="btn btn-lg mt-4" [ngStyle]="{
                            backgroundColor: (Merchant$ | async)?.webapp_settings
                              ?.menu_color,
                            color: (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae,
                            border:
                              (Merchant$ | async)?.webapp_settings?.menu_border_width +
                              'px solid ' +
                              (Merchant$ | async)?.webapp_settings?.menu_border_color,
                          }">
              Sign In
            </button>
          </div>
        </form>
      </div>
      <div class="login-box-footer clearfix text-center">
        <div class="sign-up-link mt-2">
          <a routerLink="/Registertion" class="btn btn-md mt-2" [ngStyle]="{
                        backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                        color: (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae,
                        width: '50%',
                        border:
                          (Merchant$ | async)?.webapp_settings?.menu_border_width +
                          'px solid ' +
                          (Merchant$ | async)?.webapp_settings?.menu_border_color,
                      }">
            Register</a>
        </div>

        <div class="sign-up-link mt-2">
          <button class="btn btn-md mt-2" (click)="SkipLogin()" [ngStyle]="{
                        backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                        color: (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae,
                        width: '50%',
                        border:
                          (Merchant$ | async)?.webapp_settings?.menu_border_width +
                          'px solid ' +
                          (Merchant$ | async)?.webapp_settings?.menu_border_color,
                      }">
            Skip this for now
          </button>
        </div>

        <div class="password-reset-link mt-2">
          <a [href]="pageModel.APIServer + '/password/reset'" class="btn btn-lg mt-2" [ngStyle]="{
                        backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                        color: (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae,
                        width: '50%',
                        border:
                          (Merchant$ | async)?.webapp_settings?.menu_border_width +
                          'px solid ' +
                          (Merchant$ | async)?.webapp_settings?.menu_border_color,
                      }">
            Reset Password?</a>
        </div>

        <div class="text-center mt-2" [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                  }">
          by continuing you agree to our<br />Terms and Privacy Policy
        </div>
      </div>
    </div>
  </section>

  <!-- Getting Guest user details as per the webapp setting flag if flag on then it will required -->
  <app-guestlogin [currentMerchant]="currentMerchant" (GuestLoginChange)="Guestlogin($event)"
    [GuestLogin]="GuestLogin"></app-guestlogin>
</div>
<ng-template #errorinfo let-model>
  <!-- Modal content -->
  <div class="modal-header" [ngStyle]="{
        'justify-content': 'right',
        height: '40px',
        backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
        'border-bottom':
          (Merchant$ | async)?.webapp_settings?.menu_border_width +
          'px solid ' +
          (Merchant$ | async)?.webapp_settings?.menu_border_color,
      }">
    <a (click)="model.close()" id="btnnotification" class="close-icon">
      <i [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
          }" class="zmdi zmdi-close zmdi-hc-fw"></i>
    </a>
  </div>
  <div class="modal-body">
    <p [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
          }" id="textcontent">
      @if (!pageModel.isInfoPopup) {
        <span>Register and/or sign in to avail relevant discounts & promotions, or,
          if option available, proceed as guest only.</span>
      }
      @if (pageModel.isInfoPopup) {
        <span>If you have previously registered with one of our toodle powered Apps
          or if you have a toodle marketplace App account you may use the same
          login credentials here. If you have forgotten your password click the
          Reset Password’ button below and a reset link will be sent to your
          registered email address.</span>
      }
    </p>
  </div>
  @if (!pageModel.isInfoPopup) {
    <div class="modal-footer justify-content-center button">
      <button id="btnclosepop" [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
                backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                border:
                  (Merchant$ | async)?.webapp_settings?.menu_border_width +
                  'px solid ' +
                  (Merchant$ | async)?.webapp_settings?.menu_border_color,
              }" (click)="model.close()">
        CONTINUE
      </button>
      </div>
  }
  @if (pageModel.isInfoPopup) {
    <div class="modal-footer button">
      <!-- <button id="btnclose"
      [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :(Merchant$ | async)?.webapp_settings?.menu_border_width +
'px solid ' +(Merchant$ | async)?.webapp_settings?.menu_border_color}"
      (click)="model.close();"> Cancel</button> -->
    </div>
  }
</ng-template>
